import { IgSelect, IgTooltip, IgTypography } from "@intelligems/ig-theme";
import {
  AudienceFilterType,
  ExpressionNodeQueryType,
  UrlMatch,
} from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";

import { useExpressionBuilderContext } from "./context";
import {
  AudienceConditionTypeOptions,
  PageTargetingConditionTypeOptions,
  pageTargetingUrlPathTypeDisabled,
} from "./utils";

export interface ConditionTypeProps {
  tempExpressionQuery: ExpressionNodeQueryType;
  onChange: (value: AudienceFilterType) => void;
  configuredUrlPathFilters?: Map<UrlMatch, number>;
}

export const ConditionType = ({
  tempExpressionQuery,
  configuredUrlPathFilters,
  onChange,
}: ConditionTypeProps) => {
  const ctx = useExpressionBuilderContext();

  let options = AudienceConditionTypeOptions;
  if (ctx?.renderContext === "pageTargeting") {
    options = PageTargetingConditionTypeOptions;
    if (
      configuredUrlPathFilters &&
      pageTargetingUrlPathTypeDisabled(
        configuredUrlPathFilters,
        tempExpressionQuery
      )
    ) {
      options = [
        {
          ...options[0],
          disabled: true,
          tooltipText:
            "You've configured an equals operator in this group. No other URL Path conditions are allowed.",
        },
        ...options.slice(1),
      ];
    }
  }

  return (
    <Grid item>
      <IgSelect
        variant={"outlined"}
        value={tempExpressionQuery.type}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      >
        {options.map((condition) =>
          !condition.disabled ? (
            <MenuItem key={`${condition.key}`} value={condition.key}>
              <Grid container direction={"column"}>
                <Grid item>
                  <IgTypography>{condition.title}</IgTypography>
                </Grid>
              </Grid>
            </MenuItem>
          ) : (
            <IgTooltip key={condition.key} title={condition.tooltipText}>
              <div>
                <MenuItem value={condition.key} disabled={condition.disabled}>
                  <Grid container direction={"column"}>
                    <Grid item>
                      <IgTypography>{condition.title}</IgTypography>
                    </Grid>
                  </Grid>
                </MenuItem>
              </div>
            </IgTooltip>
          )
        )}
      </IgSelect>
    </Grid>
  );
};
